// extracted by mini-css-extract-plugin
module.exports = {"root":"Quote_root__8yKz2","author":"Quote_author__JIN7B","subauthor":"Quote_subauthor__viCrl"};